import { inventoryAttachment, inventoryRestZ, round3, type RestMover, type RestWorld } from '../inventory/floor-move';

export interface PlacementPoint { x: number; y: number; z: number }

/** New objects and campsite props use the same support and attachment decision as floor moves. */
export function planInventoryPlacement(world: RestWorld, mover: RestMover, point: PlacementPoint, contact = true): {
  position: PlacementPoint; mounted: boolean; rest: string;
} {
  if (![point.x, point.y, point.z].every(Number.isFinite)) throw new Error('placement:position-unavailable');
  const rest = inventoryRestZ(world, mover, point.x, point.y, point.z, contact);
  const attachment = inventoryAttachment(world, mover, point.x, point.y, rest.z, contact);
  return { position: { x: round3(point.x), y: round3(point.y), z: round3(rest.z) },
    mounted: mover.mounted || attachment !== null, rest: rest.rest };
}
